const scheduledHandlers = new Set();
const currentWatchers = [];
let numWatchers = 0;
let workScheduled = false;
let nextTickPromise;
let jobId = 0;

const setCurrentWatcher = (watcher) => {
    numWatchers = currentWatchers.push(watcher);
};

const getCurrentWatcher = () => {
    return currentWatchers[numWatchers - 1];
};

export const getInternals = () => {
    return {
        scheduledHandlers,
        currentWatchers,
        numWatchers,
        jobId,
        workScheduled,
    };
};

const clearCurrentWatcher = () => {
    currentWatchers.pop();
    numWatchers = currentWatchers.length;
};

const scheduleWatchers = (dependency) => {
    if (dependency && dependency.isDependency) {
        const watchers = dependency.getWatchers();
        if (watchers) {
            watchers.forEach((watcher) => {
                // we want to make sure that already scheduled watchers are appended to the end of the list
                if (scheduledHandlers.has(watcher.notify)) {
                    scheduledHandlers.delete(watcher.notify);
                }
                scheduledHandlers.add(watcher.notify);
                scheduleWatchers(watcher);
            });
            scheduleWork();
        }
    }
};

const scheduleHandler = (handler) => {
    scheduledHandlers.add(handler);
    scheduleWork();
};

const unscheduleHandler = (handler) => {
    scheduledHandlers.delete(handler);
};

const notify = (handlers) => {
    handlers.forEach((handler) => {
        handlers.delete(handler);
        handler();
    });
    handlers.clear();
};

const nextTick = () => {
    if (nextTickPromise === undefined) {
        nextTickPromise = new Promise((resolve) => {
            resolve();
        });

        nextTickPromise.then(() => {
            nextTickPromise = undefined;
        });
    }

    return nextTickPromise;
};

/** @type { ( performWork:()=>void )=>void }  */
let manualTickOverride;

/**
 *
 * @param { typeof manualTickOverride } handler
 */
export const setManualTickOverride = (handler) => {
    manualTickOverride = handler;
};

const scheduleWork = async () => {
    if (workScheduled) {
        return;
    }

    workScheduled = true;
    jobId += 1;
    if (manualTickOverride) {
        // Provide the capability to run the schedule tasks using a different
        // method - i.e. requestAnimationFrame or requestIdleCallback
        manualTickOverride(() => {
            performWork();
            workScheduled = false;
        });
    } else {
        // Original Promise based approach
        await nextTick();
        performWork();
        workScheduled = false;
    }
};

const performWork = () => {
    notify(scheduledHandlers);
};

const getCurrentJobId = () => jobId;

export {
    scheduleWork,
    setCurrentWatcher,
    getCurrentWatcher,
    clearCurrentWatcher,
    scheduleWatchers,
    scheduleHandler,
    unscheduleHandler,
    getCurrentJobId,
};
